import { connect } from 'react-redux';
import SelectDeliverySupplierModal from '../components/SelectDeliverySupplierModal/SelectDeliverySupplierModal';
import { getMemberType } from '../selectors/converterSelector';
import { requestInfo, requestSupplierAddresses } from '../actions/userActions';
import { getAddressList } from '../selectors/addressSelector';

const mapStateToProps = function(store) {
    return {
        initialized: !store.user.isLoading.basicInfo,
        userIsLoading: store.user.isLoading,
        user: store.user.info,
        userAddresses: getAddressList(
            store.user.info.availableAddresses,
            store.address.list
        ),
        supplierInfo: store.user.supplierInfo,
        fullAddressList: store.address.list,
        loggedIn: store.user.loggedIn,
        orderOnBehalf: store.user.orderOnBehalf,
        memberType: getMemberType(store),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {
        requestInfo: (offset,limit,search) => dispatch(requestInfo(offset,limit,search)),
        requestSupplierAddresses: (id) =>
            dispatch(requestSupplierAddresses(id)),
    };
};
const ConnectedSelectDeliverySupplierModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectDeliverySupplierModal);

export default ConnectedSelectDeliverySupplierModal;
